// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__NipFP","modal":"Modal_modal__z-R4V","slide-down":"Modal_slide-down__ahiYF"};